import { useContext } from 'react';
import {
  MenuBalanceContext,
  MenuBalanceContextType,
} from 'moduleBase/modules/menu-balance/contexts/menu-balance-context';

const useMenuBalanceContext = (): MenuBalanceContextType => useContext<MenuBalanceContextType>(MenuBalanceContext);

export { useMenuBalanceContext };
